// @flow
import * as React from 'react'
import config from 'config'

type SVGContainerProps = {
  children?: React.Node,
  className: string,
  height?: number,
  width?: number
}

/**
 * Renders an SVG container.
 *
 * This simplifies layering various parts of the image above each other,
 * since these all share the same view box and preserve aspect ratio.
 *
 * @param {SVGContainerProps} props
 */
export function SVGContainer ({
  children,
  className,
  width = config.mapWidth,
  height = config.mapHeight
}: SVGContainerProps): React.Element<'svg'> {
  return (
    <svg
      className={className}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio='xMidYMid meet'
    >
      {children}
    </svg>
  )
}

export default SVGContainer
